import React from "react";

const SCORES = Array.from({ length: 11 }, (_, score) => score);

const tone = (score) => {
  if(score <= 6) {
    return "detractor";
  }
  return score <= 8 ? "passive" : "promoter";
};

export default function NpsStep({ failed, onSelect, question, score, submitting }) {
  return (
    <div className="survey-step">
      <h2 className="survey-headline">{question.headline}</h2>
      <div className="survey-nps">
        {SCORES.map((option) => (
          <button
            className={`survey-nps-score ${tone(option)}${score === option ? " selected" : ""}`}
            disabled={submitting}
            key={option}
            onClick={() => onSelect(option)}
            type="button"
          >
            {option}
          </button>
        ))}
      </div>
      <div className="survey-nps-labels">
        <span>{question.lowLabel}</span>
        <span>{question.highLabel}</span>
      </div>
      {failed && (
        <p className="survey-error">Sorry, something went wrong. Please try again.</p>
      )}
    </div>
  );
}
